import { useEffect } from 'react';

/**
 * useScrollPerformance
 * Adds `is-scrolling` class to <html> during active scrolling so the CSS
 * layer can pause expensive animations (blur, conic-gradient rotations,
 * pulses) until scroll ends. Massively smooths out desktop + mobile scroll
 * on pages with many concurrent animations & backdrop-filters.
 */
export default function useScrollPerformance() {
  useEffect(() => {
    const root = document.documentElement;
    let timeoutId = null;
    let rafId = null;
    let scrolling = false;

    const stopScrolling = () => {
      scrolling = false;
      root.classList.remove('is-scrolling');
    };

    const onScroll = () => {
      if (!scrolling) {
        scrolling = true;
        rafId = requestAnimationFrame(() => {
          root.classList.add('is-scrolling');
        });
      }
      if (timeoutId) clearTimeout(timeoutId);
      // 140ms after last scroll event → declare scroll end
      timeoutId = setTimeout(stopScrolling, 140);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (timeoutId) clearTimeout(timeoutId);
      if (rafId) cancelAnimationFrame(rafId);
      root.classList.remove('is-scrolling');
    };
  }, []);
}
